module.exports = __webpack_public_path__ + "static/sheep-c0d96ef31eb21d14f305be3aee14f97c.jpeg";